import React from 'react';

export const getOrderContactOptionGroup = option => option.group;

export const checkIsOrderContactOptionDisabled = option => !!option.isDisabled;

export const checkIsSameOrderContactOption = (option, value) => option.value === value?.value;

export const getInputPropsWithLeadingEndAdornment = ({ InputProps, leadingAdornment }) => ({
  ...InputProps,
  endAdornment: (
    <>
      {leadingAdornment}
      {InputProps.endAdornment}
    </>
  ),
});
